import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=6a639da6&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=js&"
export * from "./SwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=6a639da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a639da6",
  null
  
)

export default component.exports